module.exports = {
	admin:'Admins can manage and remove members.',
	editor:'Editors can add and edit content, and can invite other people.',
	viewer:'Viewers can view and play content.'
}




// WEBPACK FOOTER //
// ./src/permissionRoleDescriptions.js